import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'signedDiff',
  standalone: true,
})
export class SignedDiffPipe implements PipeTransform {
  transform(value: number | null | undefined, suffix: string): string {
    if (value === null || value === undefined) return '—';
    if (value === 0) return 'Same';
    const sign = value > 0 ? '+' : '−';
    return `${sign}${Math.abs(value)} ${suffix}`;
  }
}
